export default "__VITE_ASSET__CHRtH5vA__"